import Vue from 'vue'
import { showToast } from '@/packages/toast'

export default Vue.extend({
  methods: {
    showToast,
  },
})
